<template>
  <div 
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
  >
    <v-container>
      <v-layout
        class="mb-3"
        align-center
        justify-space-between
        wrap
      >
        <v-flex md4 order-sm2 class="mb-3">
          <v-text-field
            solo
            label="Search Activites"
            prepend-icon="search"
            v-model="search"
          ></v-text-field>
        </v-flex>
        <v-flex md4 order-sm1>
          <strong>
            <span class="primary--text">{{ activitiesCount }}</span>
            <span>Latest Activities</span>
          </strong>
          <span>as of {{ dateToday }}</span>
        </v-flex>
      </v-layout>

      <v-card>
        <v-list
          two-line
          subheader
        >
          <v-list-tile avatar v-for="(activity, i) in filteredActivities" :key="i">
            <v-list-tile-avatar>
              <img :src="activity.module.image"/>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ activity.module.title }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-if="activity.earned">
                  Completed
                  {{ }}
                </span>
                <span v-else>
                  <a @click="handleClick(activity.module)">Continue</a>
                </span>
                <span> - </span>
                <span>{{ convertDate(activity.created_at) }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <!--<v-list-tile-avatar color="primary">
              <span class="white--text headline">{{ activity.earned }}</span>
            </v-list-tile-avatar>-->
          </v-list-tile>
        </v-list>
      </v-card>

    </v-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  computed: {
    activitiesCount () {
      return this.filteredActivities.length
    },
    dateToday () {
      return moment().format('LL')
    },
    filteredActivities () {
      return this.activities.sort((a, b) => a.created_at < b.created_at)
    }
  },
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      search: ''
    }
  },
  methods: {
    handleClick (module) {
      this.$router.push('/module/' + module.id)
    },
    convertDate (date) {
      return moment(date).format('LL')
    },
    onlyEarnedPoints (i) {
      return i.earned > 0
    }
  },
  props: {
    user: {
      default: null
    },
    activities: {
      type: Array,
      default: () => []
    },
    certificates: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/activities.vue